import { ApartmentBuildingModel } from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter';
import { hasFilterUrl } from '@source/utilities/filters/urls';
import { translateItem } from '@source/utilities/hooks';

import { Filters } from './construct-filters';

export const setApartmentFilters = async (
    apartmentBuildings: ApartmentBuildingModel[],
    filters: Filters,
) => {
    const hasApartmentBuildings = apartmentBuildings.length > 0;

    if (hasApartmentBuildings) {
        const filterName = FILTER_NAMES.apartmentBuildings;

        filters[filterName] = {
            expanded: false,
            icon: 'icons-pin-outline',
            title: await translateItem('Filters.apartmentBuildings.label'),
            dropdownLabel: await translateItem('Filters.apartmentBuildings.dropdownLabel'),
            filterFunctions: {
                constructionNumber: (constructionNumber, filterInput) =>
                    constructionNumber.apartmentBuilding?.id === filterInput.value,
                propertyType: (propertyType, filterInput) =>
                    !!propertyType.apartmentBuildings?.length &&
                    propertyType.apartmentBuildings.map(({ id }) => id).includes(filterInput.value),
                projectPhase: (projectPhase, filterInput) =>
                    projectPhase.id ===
                    apartmentBuildings.find((building) => building.id === filterInput.value)!.id,
            },
            filterName,
            hasRangeValues: false,
            filters: {
                type: 'checkbox',
                components: apartmentBuildings.map((apartmentBuilding) => ({
                    id: `${filterName}-${apartmentBuilding.displayName}`,
                    label: `${apartmentBuilding.displayName}`,
                    value: `${apartmentBuilding.id}`,
                    name: filterName,
                    checked: hasFilterUrl(`${apartmentBuilding.id}`, filterName),
                    type: 'checkbox',
                })),
            },
        };
    }
};
